import type { TextFieldProps } from "@mui/material";
import { TextField } from "@mui/material";
import React from "react";

import { DEFAULT_INPUT_SIZE } from "globalConstants/input";

import { useStyles } from "./styles";

export const TextInput = React.forwardRef<HTMLDivElement, TextFieldProps & { dataCy?: string }>(
  ({ helperText = " ", ...props }, ref) => {
    const { classes } = useStyles();

    return (
      <TextField
        FormHelperTextProps={{ className: classes.helperText }}
        ref={ref}
        size={DEFAULT_INPUT_SIZE}
        {...props}
        inputProps={{ "data-cy": props.dataCy, ...props.inputProps }}
        helperText={helperText}
      />
    );
  },
);
